import { type IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';
import { type DatasetRegistryService } from 'app/registries/dataset/dataset-registry.service';
import { type LinkedServiceRegistryService } from 'app/registries/linked-service/linked-service-registry.service';

export function getSupportedLookupDatasetConfig(services: { datasetRegistry: DatasetRegistryService }) {
    const { datasetRegistry } = services;
    const allDatasetConfig = datasetRegistry.getAllPrimaryAndAvailableDatasetConfigurations();
    const supportLookupDatasetConfig = allDatasetConfig.filter(
        (m) => !m.notSupportLookupActivity && m.type.toLowerCase() !== 'mdsdataset'
    );
    return supportLookupDatasetConfig;
}

export function getSupportedCopySourceDatasetConfig(services: { datasetRegistry: DatasetRegistryService }) {
    const { datasetRegistry } = services;
    const allDatasetConfig = datasetRegistry.getAllPrimaryAndAvailableDatasetConfigurations();
    const supportCopySourceDatasetConfig = allDatasetConfig.filter((m) => m.isSource && !m.notSupportCopy);
    return supportCopySourceDatasetConfig;
}

export function getAllowedFileFormatsFromDatasetConfig(configs: IDatasetTypeMetadata[]) {
    return configs.filter((c) => c.isV2FormatDataset).map((c) => c.type);
}

export function getSupportedLinkedServiceTypesFromDataset(
    configs: IDatasetTypeMetadata[],
    isTrident: boolean,
    services: { lsRegistry: LinkedServiceRegistryService }
) {
    return configs
        .map((c) => c.supportLinkedServiceTypes)
        .reduce((a, b) => a.concat(b), [])
        .filter((c) => {
            const metadata = services.lsRegistry.getLinkedServiceConfiguration(c);
            return (!isTrident || metadata.supportedInTrident) && !metadata.nativeCDCOnly;
        });
}
